<template>
  <el-row class="create-ad-container">
    <div
      v-if="isMobile"
      class="back-menu mobile-position-fixed"
    >
      <mobile-back-menu
        :emit-name="'verifyModal'"
        :title="item.id ? $t('edit-ad.mobile.mobile-title') : $t('create-ad.mobile.mobile-title')"
        @verifyModal="openModal"
      />
    </div>
    <div
      v-loading="loading"
      class="create-ad-wrapper"
    >
      <h3
        v-if="!isMobile"
        class="create-title"
      >
        {{ item.id ? $t('edit-ad.title.text') : $t('create-ad.title.text') }}
      </h3>
      <el-form
        ref="form"
        :model="form"
        @submit.native.prevent="onSubmit"
      >
        <el-form-item :error="error('files') || error('newFiles')">
          <photos-upload
            v-model="form.files"
            :editing="item.id"
            :sortable="true"
            @input="() => { change('files'); change('newFiles') }"
          />
        </el-form-item>
        <el-form-item :error="error('category.id')">
          <span class="title">{{ $t('create-ad.category.label') }}</span>
          <!--{{ categoryData.category }}-->
          <category-popup
            v-model="categoryData"
            @change="change('category.id')"
          />
        </el-form-item>
        <el-form-item :error="error('name')">
          <span class="title">{{ $t('create-ad.title.label') }}</span>
          <el-input
            v-model="form.name"
            class="ad1-title"
            :placeholder="$t('create-ad.title.placeholder')"
            @change="change('name')"
          />
        </el-form-item>
        <el-form-item :error="error('description')">
          <span class="title">{{ $t('create-ad.description.label') }}</span>
          <quill-editor
            ref="quillEditor"
            v-model="form.description"
            :options="descriptionEditorOptions"
            @input="change('description')"
          />
        </el-form-item>
        <div
          v-if="!excludePriceAndCurrency"
          class="group"
        >
          <el-form-item
            class="price"
            :error="error('price') || error('currency.id')"
          >
            <el-col
              :span="8"
              :sm="4"
            >
              <span class="title">{{ $t('create-ad.price.label') }}</span>
              <el-input
                v-model="form.price"
                class="ad1-price"
                :controls="false"
                :placeholder="'0.000'"
                @change="change('price')"
              />
              <!--<app-input-number-->
              <!--v-model="form.price"-->
              <!--class="ad1-price"-->
              <!--:min="0"-->
              <!--:controls="false"-->
              <!--:placeholder="'0.000'"-->
              <!--@change="change('price')"-->
              <!--&gt;-->
              <!--</app-input-number>-->
            </el-col>
            <el-col
              :span="16"
              :sm="4"
            >
              <span class="title">{{ $t('create-ad.currency.label') }}</span>
              <select-js
                v-model="form.currency"
                :searchable="false"
                resource="currencies"
                item-name="code"
                :autoload="true"
                @change="change('currency.id')"
              />
            </el-col>
          </el-form-item>
        </div>
        <h3 class="create-title contact">
          {{ $t('create-ad.contact.label') }}
        </h3>
        <el-form-item :error="error('contact_info.phone')">
          <span class="title">{{ $t('create-ad.phone.label') }}</span>
          <el-input
            v-model="form.contact_info.phone"
            :class="reverseText"
            class="ad1-phone"
            :placeholder="$t('create-ad.phone.placeholder')"
            @change="change('contact_info.phone')"
          />
        </el-form-item>
        <el-form-item :error="error('contact_info.location') || error('contact_info.longitude') || error('contact_info.latitude')">
          <span class="title">{{ $t('create-ad.location.label') }}</span>
          <div class="location-input-wrapper">
            <gmap-place-input
              ref="gmapInput"
              :placeholder="$t('create-ad.location.text')"
              class-name="ad1-location"
              :default-place="form.contact_info ? form.contact_info.location : ''"
              @place_changed="onPlaceChanged"
            />
          </div>
        </el-form-item>
        <el-button
          class="main-large save-button"
          @click="onSubmit"
        >
          {{ $t('create-ad.submit.text') }}
        </el-button>
      </el-form>
    </div>
    <!--    <div v-if="isMobile">-->
    <!--      <footer-menu></footer-menu>-->
    <!--    </div>-->
    <el-dialog
      class="custom-verify-dialog"
      :visible.sync="verifyDialog"
      :modal-append-to-body="false"
    >
      <template slot="title">
        <h2 class="m-0">
          {{ $t('create-ad.verify-dialog.title') }}
        </h2>
      </template>
      <p class="content">
        {{ $t('create-ad.verify-dialog.content') }}
      </p>
      <template slot="footer">
        <el-button
          type="primary"
          class="mb-1"
          @click="onSubmit"
        >
          {{ $t('create-ad.verify-dialog.submit') }}
        </el-button>
        <el-button
          type="primary"
          @click="routeTo({ name: 'Home' })"
        >
          {{ $t('create-ad.verify-dialog.cancel') }}
        </el-button>
      </template>
    </el-dialog>
    <el-progress
      v-if="progress !== -1"
      class="progress-overlay"
      type="circle"
      :percentage="progress"
      :status="progressStatus"
    />
  </el-row>
</template>

<script>
/* eslint-disable import/first,no-undef */
import Vue from 'vue';
import { mapState } from 'vuex';
import { dataGet } from '@fps/vue-toolkit/dist/util';
import { objToFormData } from '@/utils';
import pickBy from 'lodash-es/pickBy';
import PhotosUpload from '@/components/PhotosUpload';
import SelectJs from '@/components/MainLeftFilters/SelectPrimaryJs';
import CategoryPopup from '@/components/CategoryPopup/CategoryPopup';
import MobileBackMenu from '@/components/Mobile/MobileBackMenu';
import ResourcePage from '@/components/Core/ResourcePage';
import numberConversion from '../filter/number-conversion';
import reversText from '@/mixins/filters/revers-text';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import defaultOptions from 'vue-quill-editor/src/options';
import VueQuillEditor, { Quill } from 'vue-quill-editor';
import $ from 'jquery'

Vue.use(VueQuillEditor/* , { default global options } */);

export default {
  components: {
    MobileBackMenu,
    CategoryPopup,
    SelectJs,
    PhotosUpload,
  },
  extends: ResourcePage,
  mixins: [
    reversText,
  ],
  data() {
    return {
      loading: false,
      progress: -1,
      progressStatus: '',
      verifyDialog: false,
      excludePriceAndCurrency: false,
      categoryData: {},
      resource: 'ads',
      autoload: true,
      resourceOptions: {
        'category:parent': true,
        currency: true,
        contact_info: true,
        attribute_values: true,
        files: true,
      },
      form: {},
      initialForm: {
        category: '',
        name: '',
        description: '',
        price: '',
        currency: '',
        files: [],
        contact_info: {
          phone: '',
          location: '',
          latitude: '',
          longitude: '',
        },
      },
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      user: state => state.auth.user,
      categories: state => state.temp.categories.list,
      locale: state => state.locale,
    }),
    descriptionEditorOptions() {
      return {
        ...defaultOptions,
        placeholder: this.$t('create-ad.description.placeholder'),
        modules: {
          ...defaultOptions.modules,
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              // ['blockquote', 'code-block'],
              [{ align: [] }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ list: 'ordered' }, { list: 'bullet' }, { header: [1, 2, 3, 4, 5, 6, false] }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ direction: 'rtl' }],
              // [{ size: ['small', false, 'large', 'huge'] }],
              [{ color: [] }, { background: [] }],
              // [{ font: [] }],
              ['clean'],
              ['link', 'image'/* , 'video' */],
            ],
            handlers: {
              image() {
                const range = this.quill.getSelection();
                const value = prompt('URL:');
                if (value) {
                  this.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
                }
              },
            },
          },
        },
      };
    },
  },
  watch: {
    categoryData(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.exclude(newVal);
      }
    },
    item: {
      immediate: true,
      handler(val) {
        if (!this.form) {
          this.form = { ...this.initialForm };
        }

        this.form = {
          ...pickBy(val, ((item, key) => Object.keys(this.initialForm).indexOf(key) !== -1)),
          contact_info: {
            ...pickBy(val.contact_info,
              ((item, key) => Object.keys(this.initialForm.contact_info).indexOf(key) !== -1)),
          },
        };
        const categoryId = dataGet('category.parent.id', val, dataGet('category.id', val));
        const category = this.categories.find(item => item.id === categoryId);
        this.categoryData = {
          category,
          subcategory: val.category ?
            category.subcategories.find(item => item.id === val.category.id) : null,
          attributeValue: [...dataGet('attribute_values', val, [])],
        };
      },
    },
    locale(val) {
      this.checkQuillEditorAlignment(val);
    },
  },
  mounted() {
    if (this.$refs.gmapInput) {
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        $(this.$refs.gmapInput.$el).find('input').attr('autocomplete', 'nope');
      }, 500);
    }

    this.checkQuillEditorAlignment(this.locale);
  },
  methods: {
    routeTo(to) {
      this.$router.push(to);
    },
    openModal() {
      this.verifyDialog = true;
    },
    exclude(category) {
      if (category && category.category && category.category.key) {
        this.excludePriceAndCurrency = category.category.key === 'jobs' || category.category.key === 'services' || category.category.key === 'education';
        if (this.excludePriceAndCurrency) {
          this.form.price = null;
          this.form.currency = { id: null };
        }
      }
    },
    setCategory(category, model) {
      this.form.category = category;
      this.form.model = model;
    },
    onPlaceChanged(result) {
      this.change('contact_info.location');
      this.change('contact_info.latitude');
      this.change('contact_info.longitude');

      this.form.contact_info = {
        ...this.form.contact_info,
        location: result.formatted_address,
        latitude: result.geometry.location.lat(),
        longitude: result.geometry.location.lng(),
      };
    },
    onSubmit() {
      if (!this.form.contact_info || (!this.form.contact_info.location && $(this.$refs.gmapInput.$el).find('input').val())) {
        this.errors = {
          ...(this.errors || {}),
          'contact_info.location': [this.$t('create-ad.invalid-location.label')],
        };
      }

      if (Object.keys(this.errors).filter(key => !!this.errors[key]).length) {
        return;
      }

      this.loading = true;
      const category = { id: dataGet('subcategory.id', this.categoryData) || dataGet('category.id', this.categoryData) };
      const formData = {
        ...this.form,
        price: numberConversion(this.form.price),
        newFiles: this.form.files ?
          this.form.files.filter(item => !item.id).map(item => item.raw) : undefined,
        files: this.form.files ?
          this.form.files.filter(item => !!item.id).map(item => ({ id: item.id, sort: item.sort })) : [],
        user_id: this.user.id,
        attribute_values: this.categoryData.attributeValue.map(item => ({ ...item, id: undefined })),
        category,
        subcategory: null,
      };
      const isUploadingFiles = formData.newFiles && formData.newFiles.length;
      if (isUploadingFiles) {
        this.progress = 0;
        this.progressStatus = '';
      }
      this.$http.post(
        this.item.id ? `ads/${this.item.id}` : 'ads',
        isUploadingFiles ? objToFormData(formData) : formData,
        {
          headers: {
            ...(isUploadingFiles ? { 'Content-Type': 'multipart/form-data' } : {}),
            ...(this.item.id ? { 'X-HTTP-METHOD-OVERRIDE': 'PUT' } : {}),
          },
          ...(isUploadingFiles ? { onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            this.progress = percentCompleted;
          } } : {}),
        })
        .then(({ data }) => {
          this.progressStatus = 'success';

          setTimeout(() => {
            this.loading = false;
            this.progress = -1;
            this.$router.push({ name: 'Ad', params: { id: data.id } });
          }, 1000);
        })
        .catch(({ response }) => {
          this.onFormError(response);
          this.progressStatus = 'exception';

          setTimeout(() => {
            this.loading = false;
            this.progress = -1;
          }, 1000);
        });
    },
    checkQuillEditorAlignment(lang) {
      if (lang && this.$refs.quillEditor) {
        const align = this.$refs.quillEditor.quill.getFormat().align;
        const value = ['ps', 'fa'].includes(lang) ? 'rtl' : null;
        if (value === 'rtl' && align == null) {
          this.$refs.quillEditor.quill.format('align', 'right', Quill.sources.USER);
        } else if (!value && align === 'right') {
          this.$refs.quillEditor.quill.format('align', false, Quill.sources.USER);
        }
        this.$refs.quillEditor.quill.format('direction', value, Quill.sources.USER);
        this.$refs.quillEditor.quill.root.dataset.placeholder = this.$t('create-ad.description.placeholder');
      }
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/pages/CreateAd.vue